import { IconButton, Typography } from '@mui/material';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { styled } from '@mui/system';
import { GenericFallbacksWrapper } from '../../../components/Fallback/GenericFallbacksWrapper';
import { cardStyles } from '../../../theme/component-styles';
import { PaneContents, PanelContainer, IPanelProps, ShowMoreButton, PanelHeader } from './Panel';

// The summary layout sizes its rows from content, so a chart sized only by
// `height: 100%` has nothing to resolve against and echarts initializes against
// the few px left over. Matches InvestmentMetricsPanel's wrapper in the same grid.
const ChartPaneContents = styled(PaneContents)`
  min-height: 275px;
`;

interface IChartPanelProps extends Omit<IPanelProps, 'paginationConfig'> {
  onExpand?: () => void;
}

export function ChartPanel({
  onExpand,
  title,
  showContentOverflow,
  showMore,
  style,
  children,
}: IChartPanelProps) {
  return (
    <GenericFallbacksWrapper>
      <PanelContainer style={{ ...cardStyles, ...(style ?? {}) }}>
        <PanelHeader>
          <Typography noWrap>{title}</Typography>
          {showMore && <ShowMoreButton url={showMore.url} title={'Go to Performance'} />}

          {onExpand && (
            <IconButton
              onClick={onExpand}
              color='secondary'
              sx={{ transform: 'rotate(45deg)', gridArea: 'pages' }}
            >
              <UnfoldMoreIcon />
            </IconButton>
          )}
        </PanelHeader>
        <ChartPaneContents showOverflow={showContentOverflow}>{children}</ChartPaneContents>
      </PanelContainer>
    </GenericFallbacksWrapper>
  );
}
